import apiClient from "../baseUrl/axiosConfig";

// Fetches published talents. `filters` is a map of fieldKey -> value, plus
// optional `q`, `page` and `per_page`.
export const getVoiceTalents = async ({
  filters = {},
  q = "",
  page = 1,
  perPage = 12,
} = {}) => {
  const params = { page, per_page: perPage };

  if (q) params.q = q;
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params[key] = value;
    }
  });

  const response = await apiClient.get("/voice-talents/list", { params });
  return response.data;
};

// Fetches the admin-enabled public directory filters.
export const getVoiceTalentFilters = async () => {
  const response = await apiClient.get("/voice-talents/filters");
  return response.data.filters;
};
